import { SVGProps, Ref, forwardRef } from 'react';

export const TrolleyOutlinedSize24Glyph = forwardRef((props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
    <svg width={24} height={24} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" ref={ref} {...props}>
        <g>
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M14.81 16.464a4 4 0 1 1-5.876 3.392L4.97 18.795c-.935-.25-1.55-.414-2.02-.475-.445-.057-.626-.002-.746.067s-.259.198-.432.612l-.013.037-.012.033L0 18.601a7 7 0 0 1 .113-.295c.25-.6.594-1.134 1.192-1.479.597-.345 1.23-.375 1.875-.292q.196.026.41.067l1.59-5.93.016-.06c.352-1.314.64-2.389.98-3.206.357-.853.82-1.552 1.597-2 .777-.45 1.614-.5 2.532-.383.882.114 1.962.404 3.285.758l.04.011 2.03.544L17.356 0 24 1.78l-.466 1.74-4.904-1.315zm-4.004 2.962a2.2 2.2 0 1 1 4.251 1.14 2.2 2.2 0 0 1-4.251-1.14M8.674 6.964c.299-.173.684-.248 1.401-.155.744.095 1.7.35 3.09.722l2.028.544-2.123 7.923a4 4 0 0 0-3.67 2.12l-4.06-1.089 1.579-5.891c.373-1.391.631-2.347.92-3.038.279-.668.536-.964.835-1.136"
                fill="currentColor"
            />
        </g>
    </svg>
));
TrolleyOutlinedSize24Glyph.displayName = 'TrolleyOutlinedSize24Glyph';
